import { useCallback, useState } from "react";

import { EditIcon } from "@dotnet/telematics-design-system";

import { DriverDataDto } from "../../../../../Pages/Drivers/interfaces";
import { DRIVERS_ACTIONS, RenderConditionOptions } from "../../../../../shared";

const useDriversInlineActions = () => {
  const [rowData, setRowData] = useState<DriverDataDto | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const openDialog = useCallback((data: DriverDataDto) => {
    setRowData(data);
    setIsOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setRowData(null);
    setIsOpen(false);
  }, []);

  const handleEditDriverClick = useCallback(
    (data: DriverDataDto) => {
      openDialog(data);
    },
    [openDialog]
  );

  const inlineActions = [
    {
      title: DRIVERS_ACTIONS.EditDriver,
      icon: <EditIcon />,
      clickAction: (data: any) => handleEditDriverClick(data),
      renderConditions: (_: RenderConditionOptions) => true
    }
  ];

  return {
    inlineActions,
    rowData,
    isOpen,
    closeDialog
  };
};

export default useDriversInlineActions;
